import React from 'react';
import PropTypes from 'prop-types';
import { Column, Row } from 'hedron';
import map from 'lodash/map';
import { NavigationLink, NavigationPath, NavigationText, Separator } from './styled';
import { buildBrandUrlWithCategory } from '../../../helpers/routes';
import BreadcrumbLink from './BreadcrumbLink';
import withCountryCode from '../../../components/RoutesHoc/RoutesHoc';

const generateBreadcrumbText = name => (
  <div>
    <Separator>&gt;</Separator>
    <NavigationText className="text">{name}</NavigationText>
  </div>
);

const getTrackingPayload = (navigationPath, department, index, brand) => {
  let payload;
  switch (index) {
    case 0:
      payload = { type: 'department', value: department };
      break;
    case 1:
      payload = { type: 'category', value: navigationPath[1].name };
      break;
    case 2:
      payload = {
        type: 'subcategory',
        value: navigationPath[2] ? navigationPath[2].name : '',
      };
      break;
    default:
      payload = {};
  }
  if (brand) {
    payload = {
      type: 'brand',
      value: brand,
    };
  }
  return payload;
};

const Breadcrumbs = ({ department, navigationPath, product, brandName, buildUrlWithCountry }) => {
  const { model, brand, brand_url, brand_id, category_path } = product || {};
  const { category_id } = category_path || {};
  return (
    <Row data-cy="breadcrumbs" style={{ marginTop: '15px' }}>
      <Column fluid>
        <NavigationPath>
          <NavigationLink data-cy="link-breadcrumb-home" href={buildUrlWithCountry()}>
            Home
          </NavigationLink>
          {map(navigationPath, (curr, index) =>
            curr.show ? (
              <BreadcrumbLink
                name={curr.name}
                url={buildUrlWithCountry(curr.url)}
                linkId={`navpath_${index}`}
                trackingPayload={getTrackingPayload(navigationPath, department, index)}
              />
            ) : null,
          )}
          {product && (
            <>
              <BreadcrumbLink
                name={brand}
                url={buildUrlWithCountry(buildBrandUrlWithCategory(brand_url, brand_id, category_id))}
                linkId="navpath_brand"
                trackingPayload={getTrackingPayload(navigationPath, department, 2, brand)}
              />
              {generateBreadcrumbText(model)}
            </>
          )}
          {brandName && generateBreadcrumbText(brandName)}
        </NavigationPath>
      </Column>
    </Row>
  );
};

Breadcrumbs.propTypes = {
  navigationPath: PropTypes.array.isRequired,
  product: PropTypes.object,
};

export default withCountryCode(Breadcrumbs);
